<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import useLocale from './helpers/use-locale';

const { t } = useLocale();

type Props = {
  color?: string;
  icon?: string;
};
withDefaults(defineProps<Props>(), {
  color: 'on-surface-medium',
  icon: 'fa-regular fa-xmark',
});
</script>

<template>
  <v-btn variant="text" class="close-btn position-absolute" :color="color" :aria-label="t('components.button_close')">
    <FontAwesomeIcon size="lg" :icon="icon"></FontAwesomeIcon>
  </v-btn>
</template>

<style scoped lang="scss">
.close-btn {
  right: 12px;
  top: 12px;
  padding: 8px;
  z-index: 1;
  aspect-ratio: 1;
  min-width: unset;
}
</style>
